/**
 * Hook principal para ingresos - Utiliza únicamente Firebase para datos reales
 */

import { useIngresosFirebase } from './useIngresosFirebase';
import { useAuth } from '../../auth/hooks/useAuth';
import { LoggerService } from '../../../shared/services/logger.service';

export const useIngresos = () => {
  const { user } = useAuth();
  
  // Debug logging
  console.log('useIngresos: Auth state:', { 
    hasUser: !!user, 
    userUid: user?.uid,
    firebaseApiKey: !!import.meta.env.VITE_FIREBASE_API_KEY,
    firebaseProjectId: !!import.meta.env.VITE_FIREBASE_PROJECT_ID
  });
  
  // Usar únicamente Firebase para datos reales
  LoggerService.info('Using Firebase ingresos (production)', 'useIngresos', { userId: user?.uid });
  console.log('useIngresos: Using Firebase data');
  
  return useIngresosFirebase();
};